import dynamic from "next/dynamic"

export const SanityAddToCartFromUrlSectionDynamic = dynamic(() =>
  import("./SanityAddToCartFromUrlSection").then((module) => module.SanityAddToCartFromUrlSection),
)

export const SanityHeroSectionButtonDynamic = dynamic(() =>
  import("./SanityHeroSectionButton").then((module) => module.SanityHeroSectionButton),
)

export const SanityCarouselSectionDynamic = dynamic(() =>
  import("./SanityCarouselSection").then((module) => module.SanityCarouselSection),
)

export const SanityFaqsSectionDynamic = dynamic(() =>
  import("./SanityFaqsSection").then((module) => module.SanityFaqsSection),
)

export const SanityHeroSectionDynamic = dynamic(() =>
  import("./SanityHeroSection").then((module) => module.SanityHeroSection),
)

export const SanityImageSectionDynamic = dynamic(() =>
  import("./SanityImageSection").then((module) => module.SanityImageSection),
)

export const SanityMarkdownSectionDynamic = dynamic(() =>
  import("./SanityMarkdownSection").then((module) => module.SanityMarkdownSection),
)

export const SanityKlaviyoSignupSectionDynamic = dynamic(() =>
  import("./SanityKlaviyoSignupSection").then((module) => module.SanityKlaviyoSignupSection),
)

export const SanitySpacingSectionDynamic = dynamic(() =>
  import("./SanitySpacingSection").then((module) => module.SanitySpacingSection),
)

export const SanityTypeformSurveyDynamic = dynamic(() =>
  import("./SanityTypeformSurvey").then((module) => module.SanityTypeformSurvey),
)
